var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Field } from 'formik';
function Error(props) {
    var message = props.message;
    return (_jsx(_Fragment, { children: message
            && _jsx("div", __assign({ className: "field__errors", style: { color: 'red' } }, { children: message })) }));
}
export function InputField(props) {
    var label = props.label, fieldName = props.fieldName, error = props.error, handleChange = props.handleChange, initialValue = props.initialValue, isRequired = props.isRequired;
    var onFocus = function (event) {
        var _a;
        var input = event.target;
        var field = (_a = input === null || input === void 0 ? void 0 : input.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (field) {
            field.classList.add('field--focused');
        }
    };
    var onBlur = function (event) {
        var _a;
        var input = event.target;
        var field = (_a = input === null || input === void 0 ? void 0 : input.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (field) {
            field.classList.remove('field--focused');
        }
    };
    var onChange = function (event) {
        var _a;
        var input = event.target;
        var field = (_a = input === null || input === void 0 ? void 0 : input.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (field) {
            if (input.value) {
                field.classList.add('field--filled');
            }
            else {
                field.classList.remove('field--filled');
            }
        }
        handleChange(event);
    };
    return (_jsxs("div", __assign({ className: "field field--single-line-text col col-6".concat(error ? ' field--error' : '').concat(initialValue ? ' field--filled' : '') }, { children: [_jsxs("label", { children: [label, isRequired ? _jsx("span", { children: "*" }) : ''] }), _jsxs("div", __assign({ className: "field__input" }, { children: [_jsx(Field, { name: fieldName, type: "text", onFocus: onFocus, onBlur: onBlur, onChange: onChange, required: isRequired !== null && isRequired !== void 0 ? isRequired : false }), _jsx(Error, { message: error })] }))] })));
}
